<template>
  <div>
    <PageHero :position="meta.position" :fallback="meta" />

    <section v-if="module === 'PRODUCT'" class="section">
      <div class="catalog-toolbar">
        <div class="filters" role="group" :aria-label="$t('listing.productGroup')">
          <button class="filter" :class="{ active: selectedCategory === null }" type="button" @click="selectedCategory = null">{{ $t('common.all') }}</button>
          <button v-for="category in flatCategories" :key="category.id" class="filter" :class="{ active: selectedCategory === category.id }" type="button" @click="selectedCategory = category.id">{{ category.name }}</button>
        </div>
        <label class="search-label">{{ $t('listing.search') }}<input v-model.trim="keyword" type="search" :placeholder="$t('listing.searchPlaceholder')" :aria-label="$t('listing.search')"></label>
      </div>
      <p class="muted">{{ $t('listing.count', { count: filteredItems.length }) }}</p>
      <div v-if="filteredItems.length" class="product-grid catalog-grid"><ContentCard v-for="(item,index) in filteredItems" :key="item.id || item.detailSlug || index" :item="item" module="PRODUCT" :index="index" /></div>
      <div v-else class="empty"><h2>{{ $t('listing.emptyTitle') }}</h2><p>{{ $t('listing.emptyText') }}</p></div>
      <p class="source-note">{{ $t('listing.productNote') }}</p>
    </section>

    <section v-else-if="module === 'SOLUTION'" class="tinted"><div class="section"><SectionHeading :eyebrow="meta.sectionEyebrow" :title="meta.sectionTitle" /><p class="section-intro">{{ $t('listing.solutionIntro') }}</p><div class="solution-grid"><ContentCard v-for="(item,index) in filteredItems" :key="item.id || item.detailSlug || index" :item="item" module="SOLUTION" variant="solution" :index="index" /></div></div></section>

    <section v-else class="section">
      <div class="case-grid four"><ContentCard v-for="(item,index) in filteredItems" :key="item.id || item.detailSlug || index" :item="item" module="CASE" variant="case" :index="index" /></div>
      <p class="source-note">{{ $t('listing.caseNote') }}</p>
      <SectionHeading :eyebrow="$t('listing.moreEyebrow')" :title="$t('listing.moreTitle')" />
      <div class="info-grid"><article><h3>{{ $t('listing.case1Title') }}</h3><p>{{ $t('listing.case1Text') }}</p></article><article><h3>{{ $t('listing.case2Title') }}</h3><p>{{ $t('listing.case2Text') }}</p></article><article><h3>{{ $t('listing.case3Title') }}</h3><p>{{ $t('listing.case3Text') }}</p></article></div>
    </section>

    <ProcessSection v-if="module === 'SOLUTION'" />
    <ContactCta />
  </div>
</template>

<script>
import PageHero from '../components/PageHero.vue'
import SectionHeading from '../components/SectionHeading.vue'
import ContentCard from '../components/ContentCard.vue'
import ProcessSection from '../components/ProcessSection.vue'
import ContactCta from '../components/ContactCta.vue'
import { getCategories, getContents } from '../api/public'
import { pageMeta, fallbackContents } from '../data/site'

export default {
  name: 'ListingView', components: { PageHero, SectionHeading, ContentCard, ProcessSection, ContactCta }, props: { module: { type: String, required: true } },
  data() { return { categories: [], items: [], selectedCategory: null, keyword: '' } },
  computed: {
    meta() { const key=this.module.toLowerCase(); return { ...pageMeta[this.module], eyebrow:this.$t(`meta.${key}.eyebrow`), title:this.$t(`meta.${key}.title`), subtitle:this.$t(`meta.${key}.subtitle`), sectionEyebrow:this.$t(`meta.${key}.sectionEyebrow`), sectionTitle:this.$t(`meta.${key}.sectionTitle`) } },
    flatCategories() { const result=[]; const walk=list=>(list||[]).forEach(item=>{ result.push(item); walk(item.children) }); walk(this.categories); return result },
    selectedIds() { if (this.selectedCategory===null) return null; const ids=new Set(); const walk=(list,active=false)=>(list||[]).forEach(item=>{ const selected=active||item.id===this.selectedCategory; if(selected) ids.add(item.id); walk(item.children,selected) }); walk(this.categories); return ids },
    filteredItems() { const term=this.keyword.toLowerCase(); return this.items.filter(item=>(!this.selectedIds||this.selectedIds.has(item.categoryId))&&(!term||`${item.title||''} ${item.summary||''} ${item.categoryName||''}`.toLowerCase().includes(term))) }
  },
  watch: { '$route.query.category': 'applyCategoryQuery', '$route.query.categoryId': 'applyCategoryQuery', '$i18n.locale': 'loadData' },
  mounted() { this.loadData() },
  methods: {
    async loadData() { const [categories,contents]=await Promise.allSettled([getCategories(this.module),getContents(this.module)]); this.categories=categories.status==='fulfilled'?(categories.value||[]):[]; this.items=contents.status==='fulfilled'?(contents.value||[]):(this.$i18n.locale==='zh-CN'?fallbackContents[this.module]:[]); this.applyCategoryQuery() },
    applyCategoryQuery() {
      const categoryId = this.$route.query.categoryId
      if (categoryId) {
        const match = this.flatCategories.find(item => String(item.id) === String(categoryId))
        this.selectedCategory = match ? match.id : null
        return
      }
      const name = this.$route.query.category
      if (!name) { this.selectedCategory = null; return }
      const match = this.flatCategories.find(item => item.name === name)
      this.selectedCategory = match ? match.id : null
    }
  }
}
</script>
